import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo } from "react";
import { useGeneralLibraryMetadata } from "~/components/LibraryBeta/hooks/useGeneralLibraryMetadata";
export const GeneralLibraryIcon = /*#__PURE__*/ memo((param)=>{
    let { className } = param;
    const { generalLibraryIcon, generalLibraryColor } = useGeneralLibraryMetadata();
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": "general-library-icon",
        className: classNames("flex size-6 items-center justify-center rounded-4 bg-grey-4 transition-colors duration-1000", className),
        style: {
            backgroundColor: generalLibraryColor.hex
        },
        children: generalLibraryIcon
    });
});
GeneralLibraryIcon.displayName = "GeneralLibraryIcon";
